/**
 * Component for Loading animation
 *
 * @module components/Loading/Loading
 */

import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../lib/utils/css';
import Icon from '../../Icon/Icon';

import { LoadingColors } from './constants';

import './Loading.scss';

export class Loading extends React.Component {
  static propTypes = {
    isWhite: PropTypes.bool,
    isHidden: PropTypes.bool,
    isAddVariety: PropTypes.bool,
    isSubscription: PropTypes.bool,
    isPayments: PropTypes.bool,
    isPaypal: PropTypes.bool,
    isBabySearch: PropTypes.bool,
    isFullPage: PropTypes.bool,
    isOpaque: PropTypes.bool,
    isMyMusicGrid: PropTypes.bool,
    isMyMusicList: PropTypes.bool,
    isRowList: PropTypes.bool,
    isCentered: PropTypes.bool,
  };

  render() {
    const containerClasses = createBEM('LoadingContainer', {
      centered: this.props.isCentered,
    });

    const loadingClasses = createBEM('Loading', {
      white: this.props.isWhite,
      hide: this.props.isHidden,
      addVariety: this.props.isAddVariety,
      subscription: this.props.isSubscription,
      payments: this.props.isPayments,
      paypal: this.props.isPaypal,
      babySearch: this.props.isBabySearch,
      fullPage: this.props.isFullPage,
      opaque: this.props.isOpaque,
      myMusicGrid: this.props.isMyMusicGrid,
      myMusicList: this.props.isMyMusicList,
      rowList: this.props.isRowList,
    });

    return (
      <span className={containerClasses}>
        <span className='visuallyHidden' aria-live='assertive'>
          Loading
        </span>
        <Icon
          className={loadingClasses}
          glyph={this.props.isWhite ? LoadingColors.WHITE : LoadingColors.BLACK}
        />
      </span>
    );
  }
}

export default Loading;
